// extracted by mini-css-extract-plugin
export default {"container":"galleryPage_container__9-Uzy","content":"galleryPage_content__VwOgx"};